import React from 'react';
import PropTypes from 'prop-types';

const SiteContent = ({ children }) => (
  <div className="bhp-site-content">
    {children}
  </div>
);

SiteContent.propTypes = {
  children: PropTypes.any.isRequired
};

export default SiteContent;
